<template>
  <div>
    <v-dialog
      content-class="dialog-fixed-top"
      v-model="showingDialog"
      max-width="1500"
    >
      <v-card v-if="dialogContents != null">
        <v-card-text class="pa-6 h-row-top">
          <div class="grow-1">
            <h3>Before</h3>
            <p v-if="mbB != null">
              <span style="display: inline-block; width: 70px">Created:</span>
              {{ mbB.createdAt }}
              <br />
              <span style="display: inline-block; width: 70px">Delivered:</span>
              {{ mbB.deliveredAt }}
            </p>
            <pre>{{ dialogContents.b || '─' }}</pre>
          </div>
          <v-divider vertical class="mx-6" />
          <div class="grow-1">
            <h3>After</h3>
            <p v-if="mbA != null">
              <span style="display: inline-block; width: 70px">Created:</span>
              {{ mbA.createdAt }}
              <br />
              <span style="display: inline-block; width: 70px">Delivered:</span>
              {{ mbA.deliveredAt }}
            </p>
            <pre>{{ dialogContents.a || '─' }}</pre>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-simple-table dense class="dense-table">
      <template v-slot:default>
        <thead>
          <tr>
            <th v-for="h in headers" :class="headerClass(h)" :key="h.key">
              {{ h.label }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(row, indexR) in pairs"
            :key="`R${indexR}`"
            class="clickable"
            :class="rowClass(row)"
            @click="showDialog(row)"
          >
            <td
              v-for="(header, indexH) in headers"
              :key="`R${indexR}_H${indexH}`"
              :class="cellClass(row, header)"
            >
              {{ cellValue(row, header) }}
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
  </div>
</template>

<script>
import _ from 'lodash'

export default {
  props: {
    // [{b: Object, a: Object, color: String}]
    pairs: { type: Array, required: true },

    // [{label: String, prop: String, align: String}]
    cols: { type: Array, required: true },

    // para mostrar datas na popup apenas
    mbB: {},
    mbA: {}
  },
  data() {
    return {
      showingDialog: false,
      dialogContents: null
    }
  },
  computed: {
    headers() {
      let result = []
      for (let col of this.cols) {
        result.push({
          key: 'B_' + col.prop,
          label: col.label || col.prop,
          prop: col.prop,
          align: col.align || 'right'
        })
      }

      for (let col of this.cols) {
        result.push({
          key: 'A_' + col.prop,
          label: col.label || col.prop,
          prop: col.prop,
          align: col.align || 'right'
        })
      }

      return result
    }
  },
  methods: {
    headerClass(h) {
      return h.align == 'right' ? 'text-right' : 'text-left'
    },
    cellClass(row, header) {
      return header.align == 'right' ? 'text-right' : 'text-left'
    },
    rowClass(pair) {
      if (pair.color) return pair.color
      if (pair.a == null && pair.b != null) return 'red lighten-4'
      if (pair.b == null && pair.a != null) return 'red lighten-4'
      return null
    },
    cellValue(row, header) {
      let obj = header.key.startsWith('B_') ? row.b : row.a
      if (obj == null) return '─'
      let val = _.get(obj, header.prop)
      if (val == null) return '─'
      return val.toString()
    },
    showDialog(row) {
      this.dialogContents = row
      this.showingDialog = true
    }
  }
}
</script>

<style></style>
